/* eslint-disable no-restricted-syntax -- framework */
/**
 * THIS NEEDS TO BE EXPORTED SO THAT THE WEBAPP CAN REGISTER THE OBJECTS IT WANTS TO USE
 * IN ITS BASE PAGE
 */
import { inject, InjectionToken } from '@angular/core';
import { ISafariObjectState, SafariReduxApiObject } from '@safarilaw-webapp/shared/redux';
import { SquirrelValue } from '../squirrel-value/models/app/squirrel-value';

import { createSelector } from '@ngrx/store';
import { SQUIRREL_VALUE_SERVICE_TOKEN } from './injectable-service-tokens';
import { PROJECT_NAME, getSharedFeatureState } from './state.interface';

export const SQUIRREL_VALUE_REDUX_OBJECT_TOKEN = new InjectionToken<SafariReduxApiObject<ISafariObjectState<SquirrelValue>, SquirrelValue>>('SQUIRREL_VALUE_REDUX_OBJECT', {
  providedIn: 'root',
  factory: () =>
    new SafariReduxApiObject<ISafariObjectState<SquirrelValue>, SquirrelValue>(
      PROJECT_NAME,
      'SquirrelValue', // <--- NEEDS TO BE UNIQUE IN THIS FILE - USED TO GENERATE UNIQUE ACTION NAME
      inject(SQUIRREL_VALUE_SERVICE_TOKEN),
      createSelector(getSharedFeatureState, state => state.squirrelCombinedState.squirrelState)
    )
});
/*** BEWARE OF DOG - DO NOT DELETE OR PUT ANYTHING ELSE BELOW THIS ***/
